import React from "react";
import classNames from "classnames";

export function Button(props: any) {
  const ref = React.useRef();

  return (
    <button
      disabled={Boolean(props.disabled)}
      className={classNames("SharedButton", props.styleClass)}
      ref={ref}
      {...props}
    />
  );
}
